import React, { ReactElement, useEffect } from "react";

import { IgTab, IgTabs } from "@intelligems/ig-theme";
import { useDispatch, useSelector } from "@src/store";
import { getTabIndex, setTabIndex } from "@src/store/slices/components/tab";

export type NavProps = Omit<
  React.ComponentProps<typeof IgTabs>,
  "value" | "onChange"
> & {
  id: string;
  defaultTab?: number;
};

const Nav = ({ id, defaultTab = 0, children, ...props }: NavProps) => {
  const dispatch = useDispatch();
  const tabIndex = useSelector(getTabIndex(id)) ?? defaultTab;

  useEffect(() => {
    dispatch(setTabIndex({ id, tabIndex }));
    return () => {
      dispatch(setTabIndex({ id }));
    };
  }, []);

  return (
    <IgTabs
      value={tabIndex}
      underline={true}
      onChange={(_ev, value) => dispatch(setTabIndex({ id, tabIndex: value }))}
      {...props}
    >
      {children}
    </IgTabs>
  );
};

const Content = ({
  id,
  children,
}: {
  id: string;
  children: React.ReactNode;
}) => {
  const tabIndex = useSelector(getTabIndex(id));
  const array = React.Children.toArray(children);
  return (array?.[tabIndex] ??
    null) as ReactElement | null as React.ReactElement<
    unknown,
    string | React.JSXElementConstructor<any>
  >;
};

// @ts-ignore
export const CustomTabs = Object.assign(Nav, { IgTab, Content });
